export default __webpack_public_path__ + "static/media/AMZ4.5cfbebf1.png";